import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { TranscriptHeaderFillerWords } from './TranscriptHeaderFillerWords';

export const TranscriptHeader = ({
  activeTranscription,
  fillerWordsPercent,
  highEnergy,
}: {
  activeTranscription: number;
  fillerWordsPercent?: string;
  highEnergy?: string;
}) => {
  const { t } = useTranslation('components', { keyPrefix: 'transcript' });

  const title = useMemo(() => {
    switch (activeTranscription) {
      case 0:
        return t('titleTranscript');
      case 1:
        return t('titleLikelyToRemember');
      case 2:
        return t('titleSentiment');
      case 3:
        return t('titleKeywords');

      default:
        throw new Error('Invalid title was used');
    }
  }, [t, activeTranscription]);

  const contentHeader = useMemo(() => {
    switch (activeTranscription) {
      case 0:
        return <TranscriptHeaderFillerWords percent={fillerWordsPercent} />;

      case 2:
        return (
          <Box display="flex" mr={4} alignItems="center">
            <Typography variant="text3" mr={1}>
              {t('energy')}
            </Typography>
            <Typography
              sx={{ backgroundColor: '#1BFFAF', borderRadius: 1, p: '2px 8px', height: 'fit-content' }}
              variant="text3"
            >{`${Math.round(Number(highEnergy)) || 0}%`}</Typography>
          </Box>
        );
      default:
        return null;
    }
  }, [t, activeTranscription, fillerWordsPercent, highEnergy]);

  return (
    <Box display="flex" justifyContent="space-between" mb={3} alignItems="center">
      <Typography variant="h4">{title}</Typography>

      {contentHeader}
    </Box>
  );
};
